import CustomButton from '@components/Button/Button';
import { Checkbox, Divider, FormControlLabel } from '@mui/material';
import { Box } from '@mui/system';
import Image from 'next/image';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { additionalSeats, removeAdditionalSeats } from '@redux/services/teams';
import { useDispatch, useSelector } from 'react-redux';
// import { setUserDetail } from '@redux/services/general';
import { setCustomAlert } from '@redux/actions/general';
import { additionalSeatsPrincing } from '@helpers/utils';

export default function AddOnPayment({
  user,
  noOfSeats,
  helperState,
  setHelperState,
  selectedTeam,
  // addOnSeatsCount,
  setActive,
  showPaymentMethod,
  setShowPaymentMethod,
  setLoadingState,
  loadingState,
  defaultCard,
}) {
  const [existingCard, setExistingCard] = useState(true);
  const dispatch = useDispatch();
  const handleCheckboxChange = () => {
    setExistingCard(!existingCard);
  };
  const {
    general: {
      additonalSeatsAndKW: { additionalSeats: newSeats },
    },
  } = useSelector((state) => state);
  const handleRemoveSeat = () => {
    setLoadingState({ remove: true, add: false });
    removeAdditionalSeats(
      {
        additionalSeats: noOfSeats?.seats,
      },
      selectedTeam?.id
    )
      .then(() => {
        // dispatch(
        //   setUserDetail({
        //     ...user,
        //     subscription: {
        //       ...user?.subscription,
        //       additionalSeats:
        //         user?.subscription?.additionalSeats - noOfSeats?.seats,
        //     },
        //   })
        // );
        setHelperState({ ...helperState });
        setActive(4);
      })
      .catch((err) => {
        dispatch(
          setCustomAlert({
            message: err?.message || 'Something went wrong! TRY AGAIN',
            state: true,
            type: 'info',
            position: 'bottom-center',
          })
        );
      })
      .finally(() => {
        setLoadingState(false);
      });
  };
  const handlePayment = () => {
    setLoadingState({ remove: false, add: true });
    additionalSeats(
      {
        additionalSeats: noOfSeats?.seats,
        cardId: defaultCard?._id,
        members: [],
      },
      selectedTeam?.id
    )
      .then(() => {
        // dispatch(
        //   setUserDetail({
        //     ...user,
        //     subscription: {
        //       ...user?.subscription,
        //       additionalSeats:
        //         +addOnSeatsCount + user?.subscription?.additionalSeats,
        //     },
        //   })
        // );
        setHelperState({ ...helperState });
        setActive(2);
      })
      .catch(() => {
        setActive(3);
      })
      .finally(() => {
        setLoadingState(false);
      });
  };
  return (
    <div>
      <Box
        className=' rounded-md  h-full w-full dark:border-1 dark:border-custom-border'
        border='1px solid #EBEBEF'
        padding='16px'
      >
        <div className='flex items-center justify-between pb-3'>
          <div className='font-bold'>Add-on</div>
          <div className='font-semibold text-secondary-blue'>
            {user?.subscription?.interval === 'year' ? 'Annual' : 'Monthly'}
          </div>
        </div>
        <div className='bg-custom-bgGrey rounded dark:bg-header-black'>
          <div className='flex items-center p-2'>
            <Image
              width={24}
              height={24}
              alt='group'
              src='/assets/group-people.svg'
            />

            <div className='pl-2'>
              Users: <b className='text-secondary-blue'>{noOfSeats?.seats}</b>
            </div>
          </div>
        </div>
      </Box>
      {showPaymentMethod ? (
        <div>
          <div className='font-bold py-3'>Payment method</div>
          <Box
            className=' rounded-md  h-full w-full dark:border-1 dark:border-custom-border'
            border='1px solid #EBEBEF'
            padding='16px'
          >
            <div className='flex items-center justify-between'>
              <div className='font-bold text-xs'>Card</div>
              <div className='font-semibold text-xs'>Exp</div>
            </div>
            <div className='flex items-center justify-between pt-2'>
              <div className='flex items-center'>
                <img src='/assets/visa.svg' alt='visa' />
                <div className=' pl-2 flex items-center'>
                  <div className='pr-2 pt-2'>****</div>
                  <div className='pr-2 pt-2'>****</div>
                  <div className='pr-2 pt-2'>****</div>
                  <div className='pr-3 font-bold'>{defaultCard?.last4}</div>
                </div>
              </div>
              <div className='font-semibold'>
                {defaultCard?.expMonth}/
                {defaultCard?.expYear.toString().slice(2)}
              </div>
            </div>
          </Box>
        </div>
      ) : null}

      {noOfSeats?.type === 'add' ? (
        <>
          <div className='flex items-center pt-3 justify-between'>
            <div className=' text-sm'>Price per License</div>
            <div className=' text-sm'>
              {/* {user?.userPlan?.name !== "Planner PRO"
                ? user?.subscription?.interval === "year"
                  ? `$${user?.userPlan?.price?.yearly}`
                  : `$${user?.userPlan?.price?.monthly}`
                : user?.subscription?.interval === "year"
                ? `$${50}`
                : `$${60}`} */}
              {`$${additionalSeatsPrincing(
                user?.userPlan?._id,
                1,
                newSeats,
                user?.subscription?.interval === 'year'
              )}`}
            </div>
          </div>
          <div className='flex items-center pt-2 justify-between'>
            <div className=' text-sm'>No. of Licenses</div>
            <div className=' text-sm'>{noOfSeats?.seats}</div>
          </div>
          <div className='flex items-center pt-3 justify-between'>
            <div className='font-bold '>Total</div>
            <div className=''>
              {/* {user?.userPlan?.name !== "Planner PRO" ? (
                user?.subscription?.interval === "year" ? (
                  <>
                    $<b>{noOfSeats?.seats * user?.userPlan?.price?.yearly}</b>
                    /yr
                  </>
                ) : (
                  <>
                    $<b>{noOfSeats?.seats * user?.userPlan?.price?.monthly}</b>
                    /mon
                  </>
                )
              ) : user?.subscription?.interval === "year" ? (
                <>
                  $<b>{noOfSeats?.seats * 50 * 12}</b>
                  /yr
                </>
              ) : (
                <>
                  $<b>{noOfSeats?.seats * 60}</b>
                  /mon
                </>
              )} */}
              {`$${additionalSeatsPrincing(
                user?.userPlan?._id,
                noOfSeats?.seats,
                newSeats,
                user?.subscription?.interval === 'year'
              )}`}
            </div>
          </div>
          {!showPaymentMethod ? (
            <div>
              <div className='flex items-center pt-3'>
                <div className='pr-2'>
                  <AnnouncementIcon className='pr-1' />
                </div>
                <div className='text-[12px]'>
                  These <b>{noOfSeats?.seats}</b> user(s) will be added to your
                  plan <br />
                  {/* <b>
                    (additional{' '}
                    {user?.userPlan?.name !== 'Planner PRO'
                      ? user?.subscription?.interval === 'year'
                        ? `$${user?.userPlan?.price?.yearly}`
                        : `$${user?.userPlan?.price?.monthly}`
                      : user?.subscription?.interval === 'year'
                      ? `$${50}`
                      : `$${60}`}{' '}
                    per user / month)
                  </b> */}
                  <b>
                    {`(additional $${additionalSeatsPrincing(
                      user?.userPlan?._id,
                      noOfSeats?.seats,
                      newSeats,
                      user?.subscription?.interval === 'year'
                    )} per user / month)`}
                  </b>
                </div>
              </div>
              <div className='flex items-center pt-4'>
                <FormControlLabel
                  classes={{ label: 'field-label' }}
                  onChange={handleCheckboxChange}
                  control={<Checkbox checked={existingCard} />}
                  label='Use my existing card on file.'
                />
              </div>
            </div>
          ) : null}
        </>
      ) : null}
      <div className='pt-4'>
        <Divider />
      </div>
      {showPaymentMethod ? (
        <div className='flex pt-4 pb-3'>
          <div className='w-[30%] pr-2'>
            <CustomButton
              btnColor='outlined'
              onClick={() => setShowPaymentMethod(!showPaymentMethod)}
            >
              Back
            </CustomButton>
          </div>
          <div className='w-[70%] pl-3'>
            <CustomButton
              btnColor='blue'
              fullWidth
              style={{
                minHeight: '45px',
              }}
              onClick={handlePayment}
              loading={loadingState?.add}
            >
              Pay
            </CustomButton>
          </div>
        </div>
      ) : (
        <div className='flex pt-4 pb-3'>
          <div className='w-[50%] pr-2'>
            <CustomButton
              loading={loadingState?.remove}
              onClick={handleRemoveSeat}
              btnColor='outlined-blue'
              style={{ minHeight: '45px' }}
              disabled={noOfSeats?.type === 'add' || !noOfSeats?.type}
              fullWidth
            >
              Remove Seat<span className='lowercase'>(s)</span>
            </CustomButton>
          </div>
          <div className='w-[50%] pl-1'>
            <CustomButton
              disabled={noOfSeats?.type === 'subtract'}
              btnColor='blue'
              style={{ padding: '10px 0px' }}
              fullWidth
              onClick={
                existingCard
                  ? () => setShowPaymentMethod(!showPaymentMethod)
                  : () => setActive(5)
              }
            >
              Proceed to Payment
            </CustomButton>
          </div>
        </div>
      )}
    </div>
  );
}
AddOnPayment.propTypes = {
  user: PropTypes.object,
  selectedTeam: PropTypes.object,
  // addOnSeatsCount: PropTypes.bool,
  // availableSeat: PropTypes.bool,
  setActive: PropTypes.func,
  showPaymentMethod: PropTypes.bool,
  loadingState: PropTypes.bool,
  setShowPaymentMethod: PropTypes.func,
  setLoadingState: PropTypes.func,
  defaultCard: PropTypes.object,
  setHelperState: PropTypes.func,
  helperState: PropTypes.object,
  noOfSeats: PropTypes.object,
};
